export default "/static/build/placeholder-1x1.gif";